import { apiService } from '@/services/Api'
import { MktuClass, MktuClassWord } from '@/services/Api/generated'
import { Loader } from '@/store/Loader.store'
import { makeAutoObservable, toJS } from 'mobx'

export class MktuClassListStore {
  classesLoader = new Loader()

  classes: MktuClass[] = []
  setClasses(classes: MktuClass[]) {
    this.classes = classes
    this.rebuildClassesMap()
  }

  classesMap: Map<Required<MktuClass['classNumber']>, MktuClass> = new Map()
  rebuildClassesMap() {
    this.classesMap.clear()
    for (let mktuClass of this.classes) {
      if (mktuClass.classNumber != null) {
        this.classesMap.set(mktuClass.classNumber, mktuClass)
      }
    }
  }

  wordsMap: Map<Required<MktuClass['classNumber']>, MktuClassWord[]> = new Map()

  get producClass() {
    return this.classes.slice(0, 34)
  }

  get servicesClass() {
    return this.classes.slice(34)
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  async getClasses() {
    if (this.classes.length !== 0) {
      return
    }

    this.classesLoader.startLoading()
    try {
      const response = await apiService.mktu.getClasses()
      if (response.status && response.data != null) {
        this.setClasses(
          response.data.map((d) => ({
            ...d,
            classNumber: Number(d.classNumber),
          }))
        )
      }
    } finally {
      this.classesLoader.stopLoading()
    }
  }

  async getWords(classNumber: Required<MktuClass['classNumber']>) {
    if (this.wordsMap.has(classNumber)) {
      return this.wordsMap.get(classNumber)
    }

    const response = await apiService.mktu.getWords({
      classNumber,
    })
    if (response.status && response.data != null) {
      const words = response.data
      this.wordsMap.set(classNumber, words)
      return words
    }
  }

  getMktuClassByNumber(number: MktuClass['classNumber']) {
    const mktuClass = this.classesMap.get(number)
    if (mktuClass == null) {
      throw new Error(`Class not found ${number}`)
    } else {
      return mktuClass
    }
  }
}

export const mktuClassListStore = new MktuClassListStore()
